import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';
import { CompanySessionService } from '@core/auth/company-session.service';

/**
 * The payment-return screen fetches a checkout scoped to the active company, so it
 * needs a company session. Mirrors the recruitment `requireCompany` guard: without a
 * company membership, send the user to onboarding.
 */
export const paymentGuard: CanActivateFn = () => {
  const session = inject(CompanySessionService);
  const router = inject(Router);

  if (session.memberships().length === 0) {
    return router.createUrlTree(['/recruitment/onboarding']);
  }

  return true;
};
